import {

  CORE_LOAD_USERGROUPS_REQUEST,
  CORE_LOAD_USERGROUPS_SUCCESS,

  CORE_LOAD_LIST_USERGROUPS_REQUEST,
  CORE_LOAD_LIST_USERGROUPS_SUCCESS,

  CORE_LOAD_USERGROUP_REQUEST,
  CORE_LOAD_USERGROUP_SUCCESS,

} from '../../types'

const initialState = []
export default {
  usergroups: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_USERGROUPS_REQUEST:
      case CORE_LOAD_LIST_USERGROUPS_REQUEST:
        return initialState
      case CORE_LOAD_USERGROUPS_SUCCESS:
      case CORE_LOAD_LIST_USERGROUPS_SUCCESS:
        if (action.payload)
          return action.payload
        else return []
      default:
        return state
    }
  },
  usergroup: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_USERGROUP_REQUEST:
        return {}
      case CORE_LOAD_USERGROUP_SUCCESS:
        if (action.payload)
          return action.payload
        else return {}
      default:
        return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/features/usergroup/reducer.js